import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Route, Switch } from "react-router";
import Search from "./Search";
import Properties from "./Properties";
import Units from "./Units";
import Context, { ContextWrapper } from "../../Context";
import AddProperty from "./AddProperty";

class Index extends Component <RoutedViewProps> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;

	render() {
		const pp = this.props.match.url;
		return <ContextWrapper>
			<Switch>
				<Route path={ pp + "/search" } component={ Search }/>
				<Route path={ pp + "/properties" } component={ Properties }/>
				<Route path={ pp + "/units" } component={ Units }/>
				<Route path={ pp + "/new" } component={ AddProperty }/>
			</Switch>
		</ContextWrapper>;
	}
}

export default Index;
